module.exports = __webpack_public_path__ + "static/media/examplePhoto.3081ca83.jpeg";